import { Box, Container } from "@mui/material"
import { useContext, useEffect, useRef } from "react";
import { ToolContext } from "../../../core/context/ToolContext";

const Chat = () => {
    const { tool_state } = useContext(ToolContext);
    const chatRef = useRef(null);
    const { __SESSION } = tool_state
    const ainfo = __SESSION.data.ainfo
    console.log(ainfo)
    const tool = {
        tool_id: process.env.REACT_APP_TID_BIZ,
        tool_name: "hrc",
        tab_label: "Client",
    };


    useEffect(() => {
        const el = chatRef.current;
        if (!el) return;

        const applyData = () => {
            el.session = ainfo;
            el.tool = tool;
        };

        customElements.whenDefined("pof-chat").then(applyData);
        el.addEventListener("pofchat:ready", applyData, { once: true });

        return () => {
        el.removeEventListener("pofchat:ready", applyData);
        };
    }, []);
    return(
        <Container sx={{height: '100%', display: 'flex', flexDirection: 'column', p:'56px !important'}} maxWidth="xl">
            <pof-chat
                ref={chatRef}
                style={{
                    width: "100%",
                    height: "80vh",
                }}
            />
         </Container>
    )
}
export default Chat;